// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1_zFn","cls2":"PaperImages-cls2_hxs PaperImages-cls1_zFn","variant-dense":"PaperImages-variant-dense_CNG"};